(function($, browser) {
	$(function() {
		if ((browser == 'Explorer') || (browser == 'MS Edge')) {
			$('button').filter('[type="submit"]').each(function() {
				var $button = $(this),
					$targetForm = $('#' + $button.attr('form')),
					$parentForm = $button.closest('form');

				if ($parentForm.length == 0) {
					$button.on('click', function() {
						$targetForm.submit();
					});
				}
			});
		}
		app.dom.$body.on('focus', '.form__field, .form__select', function() {
			var $field = $(this),
				$label = $field.closest('label');

			$field.add($label).addClass('jsFocus');
		}).on('blur', '.form__field, .form__select', function() {
			var $field = $(this),
				$label = $field.closest('label');

			if ($field.val().trim() !== '') {
				$field.add($label).addClass('jsFocus');
			} else {
				$field.add($label).removeClass('jsFocus');
			}
		});
	});
})(jQuery, app.device.BrowserDetect.browser);